export default __webpack_public_path__ + "static/media/tadesse.7ec2862e.jpg";